import React from 'react';
import styled from 'styled-components';
import { media } from 'lib/style-utils';

const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
`;

const Dummy = styled.div`
  width: 100%;
  height: 188px;

  ${media.mobile`
    height: 120px;
  `}
`;

/** Color Dot */
const Dot = styled.div`
  width: 10px;
  height: 10px;
  margin: 0 auto 20px;
  border-radius: 50%;
  background: ${(props) => props.color};
`;

/** Title */
const Contact = styled.div`
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  letter-spacing: 1.2px;
  color: #343434;
  margin-bottom: 50px;

  ${media.mobile`
    font-size: 20px;
    letter-spacing: 1px;
    margin-bottom: 29px;
  `}
`;

/** About Brand */
const Description = styled.div`
  margin: 0 auto;
  max-width: 630px;
  font-family: 'Noto Sans KR', sans-serif;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.8;
  color: #444444;
  padding: 0 10px;
  word-break: keep-all;

  ${media.mobile`
    font-size: 16px;
    padding: 0 34px;
  `}
`;

const Title = ({color}) => (
  <Wrapper>
    <Dummy/>
    <Dot color={color}/>
    <Contact>CONTACT</Contact>
    <Description>
      미국 브랜드 베이비디디(Babydeedee)에 대한 WHOLESALE, 협업, 협찬 문의는
      아래 문서를 작성해주시면 확인 후 연락드리겠습니다.
    </Description>
  </Wrapper>
);

export default Title;



// WEBPACK FOOTER //
// ./src/components/Contact/Title.js